import { eventsRoutes } from "features/admin/events/EventsRoutes";
import { RouteObject } from "react-router-dom";

export const adminRoutes: RouteObject = {
  id: "admin",
  path: "admin",
  children: [eventsRoutes],
};
